import { render, staticRenderFns } from "./RefferalShare.vue?vue&type=template&id=ec23884e&"
import script from "./RefferalShare.vue?vue&type=script&lang=js&"
export * from "./RefferalShare.vue?vue&type=script&lang=js&"
import style0 from "./RefferalShare.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports